function Checkbox(props) {
  return (
    <div className={'rtds-input rtds-input-field ' + (props.classDiv ?? '')} hidden={props.hidden}>
      <div className={(props.classDivInput ?? 'rtds-flex rtds-gap-2 rtds-items-center') + (props.inputErrors?.includes(props.id) ? ' has-error' : '')}>
        <input
          required={!!props.required}
          id={props.id}
          name={props.id}
          className={props.classInput + (props.disabled ? ' sx-disabled' : ' ')}
          type='checkbox'
          aria-describedby={props.id + 'Error'}
          onChange={(event) => props.onChange(event)}
          aria-invalid={props.inputErrors?.includes(props.id)}
          checked={props.checked}
          defaultChecked={props.defaultChecked}
          minLength={props.minLength}
          maxLength={props.maxLength}
          disabled={props.disabled}
          pattern={props.pattern}
          hidden={props.hidden}
          title={props.title}
        />
        <label htmlFor={props.id} className={'rtds-input-checkbox__label ' + (props.classLabel ?? '')}>
          {props.label}{props.required ? ' ' : ''}
          <abbr
            hidden={!props.required}
            className='rtds-font-bold rtds-no-underline'
            title='obbligatorio'
          >
            *
          </abbr>
        </label>
      </div>
        {/* {
          props.inputErrors?.includes(props.id) && 
          <svg
            className='rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 rtds-absolute rtds-right-4 rtds-content-placeholder rtds-content-error'
            aria-hidden='true'
            focusable='false'
            role='img'
          >
            <use
              xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--exclamation-circle`}
            />
          </svg>
        } */}
    

      <span className='rtds-input-field__hint' hidden={!props.inputErrors?.includes(props.id)}>
        <span
          className='rtds-input-field__error'
          id={props.id + 'Error'}
          aria-live='assertive'
        >
          {props.errorMessage ?? 'Campo obbligatorio'}
        </span>
      </span>
    </div>
  );
}

export default Checkbox;
